export const VTMN_TOAST_TIMEOUT = 4500;
export const INFINITE_TIMEOUT_MS = 9999000;
export const CSS_ANIMATION_TIME_MS = 500; // sum total animation css + safety threshold
